import React, { useState, useEffect, useRef, useCallback } from 'react';

const ImageCarousel = ({ slides, autoRotateTime = 5000 }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const autoRotateRef = useRef(null);

  // Function to move to the next slide wrapped in useCallback
  const nextSlide = useCallback(() => {
    setCurrentIndex((prevIndex) => 
      prevIndex === slides.length - 1 ? 0 : prevIndex + 1
    );
  }, [slides.length]);

  // Set up auto-rotation
  useEffect(() => {
    if (!isPaused) {
      autoRotateRef.current = setInterval(nextSlide, autoRotateTime);
    }
    
    return () => {
      if (autoRotateRef.current) {
        clearInterval(autoRotateRef.current);
      }
    };
  }, [isPaused, autoRotateTime, nextSlide]); // Removed currentIndex as it's not needed

  // Pause auto-rotation when mouse is over the carousel
  const handleMouseEnter = () => {
    setIsPaused(true);
  };

  const handleMouseLeave = () => {
    setIsPaused(false);
  };

  return (
    <div 
      className="carousel-container"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div className="carousel-slides">
        {slides.map((slide, index) => (
          <div 
            key={index}
            className={`carousel-slide ${index === currentIndex ? 'active' : ''}`}
            style={{ 
              backgroundImage: `url(${slide.image})`,
              opacity: index === currentIndex ? 1 : 0
            }}
          >
            <div className="carousel-caption">
              <h2>{slide.title}</h2>
              <p>{slide.description}</p>
            </div>
          </div>
        ))}
      </div>
          
      {/* Dark overlay for better text readability */}
      <div className="carousel-overlay"></div>
    </div>
  );
};

export default ImageCarousel;